//#region src/resources/conversation-inspector/ConversationInspectorResource.mocks.ts
var e = 400, t = (t, n = e) => new Promise((e) => {
	setTimeout(() => e(t), n);
}), n = (e) => ({
	conversationId: e,
	organizationId: "my-org-id",
	setup: {
		passageRetrievalModel: "Coveo Relevance Generative Answering",
		agent: "Support Agent",
		searchHub: "default"
	},
	turns: [
		{
			turnNumber: 1,
			query: "How do I set up content security policies?",
			answer: "## Setting Up Content Security Policies\n\nTo configure content security policies (CSP) in your Coveo organization, follow these steps:\n\n1. Navigate to **Organization Settings** > **Security**.\n2. Under the **Content Security Policy** section, click **Add directive**.\n3. Specify the directive type (e.g., `script-src`, `style-src`) and the allowed sources.\n4. Click **Save** to apply the changes.\n\n> **Note:** Changes to CSP directives may take up to 15 minutes to propagate across all endpoints.\n\nFor more details, refer to the [Content Security Policy documentation](https://docs.coveo.com/en/csp).",
			retrievedPassages: [
				{
					passageId: "passage-001",
					primaryId: "doc-security-policies-001",
					passageScore: .92,
					title: "Configuring Content Security Policies",
					text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
					uri: "https://docs.coveo.com/en/content-security-policies",
					clickUri: "https://docs.coveo.com/en/content-security-policies"
				},
				{
					passageId: "passage-002",
					primaryId: "doc-security-overview-002",
					passageScore: .85,
					title: "Security Overview",
					text: "Coveo provides multiple layers of security including content security policies, search token authentication, and privilege-based access control. Each layer can be configured independently to match your organization requirements.",
					uri: "https://docs.coveo.com/en/security-overview",
					clickUri: "https://docs.coveo.com/en/security-overview"
				},
				{
					passageId: "passage-003",
					primaryId: "doc-csp-directives-003",
					passageScore: .78,
					title: "CSP Directive Reference",
					text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
					uri: "https://docs.coveo.com/en/csp-directives",
					clickUri: "https://docs.coveo.com/en/csp-directives"
				},
				{
					passageId: "passage-004",
					primaryId: "doc-troubleshooting-004",
					passageScore: .61,
					title: "Troubleshooting CSP Violations",
					text: "If you encounter CSP violation errors in the browser console, check that all required domains are included in your CSP directives. Common issues include missing CDN domains for Coveo JavaScript libraries and missing API endpoint domains.",
					uri: "https://docs.coveo.com/en/csp-troubleshooting",
					clickUri: "https://docs.coveo.com/en/csp-troubleshooting"
				}
			],
			citedPassageIds: ["passage-001", "passage-003"]
		},
		{
			turnNumber: 2,
			query: "What are the supported CSP directive types?",
			answer: "The supported CSP directive types are:\n\n- `script-src` — Controls which scripts can be executed\n- `style-src` — Controls which stylesheets can be applied\n- `img-src` — Controls which images can be loaded\n- `font-src` — Controls which fonts can be loaded\n- `connect-src` — Controls which URLs can be accessed via fetch/XHR\n- `frame-src` — Controls which URLs can be embedded in frames\n\nEach directive accepts a list of allowed sources including `self`, specific domains, and nonce-based values.",
			retrievedPassages: [{
				passageId: "passage-005",
				primaryId: "doc-csp-directives-003",
				passageScore: .95,
				title: "CSP Directive Reference",
				text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
				uri: "https://docs.coveo.com/en/csp-directives",
				clickUri: "https://docs.coveo.com/en/csp-directives"
			}, {
				passageId: "passage-006",
				primaryId: "doc-csp-advanced-005",
				passageScore: .72,
				title: "Advanced CSP Configuration",
				text: "For advanced use cases, you can combine multiple directives and use wildcard patterns. The default-src directive serves as a fallback for any directive not explicitly specified.",
				uri: "https://docs.coveo.com/en/csp-advanced",
				clickUri: "https://docs.coveo.com/en/csp-advanced"
			}],
			citedPassageIds: ["passage-005"]
		},
		{
			turnNumber: 3,
			query: "Can I use wildcards in CSP sources?",
			answer: null,
			retrievedPassages: [{
				passageId: "passage-007",
				primaryId: "doc-csp-advanced-005",
				passageScore: .55,
				title: "Advanced CSP Configuration",
				text: "For advanced use cases, you can combine multiple directives and use wildcard patterns. The default-src directive serves as a fallback for any directive not explicitly specified.",
				uri: "https://docs.coveo.com/en/csp-advanced",
				clickUri: "https://docs.coveo.com/en/csp-advanced"
			}],
			citedPassageIds: null
		},
		{
			turnNumber: 4,
			query: "How long does it take for CSP changes to propagate?",
			answer: "Changes to CSP directives may take up to **15 minutes** to propagate across all endpoints. During this propagation period, some requests may still be evaluated against the previous policy.",
			retrievedPassages: [{
				passageId: "passage-008",
				primaryId: "doc-security-policies-001",
				passageScore: .88,
				title: "Configuring Content Security Policies",
				text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
				uri: "https://docs.coveo.com/en/content-security-policies",
				clickUri: "https://docs.coveo.com/en/content-security-policies"
			}],
			citedPassageIds: ["passage-008"]
		}
	]
});
//#endregion
export { n as createMockConversationDebugResponse, t as withDelay };

//# sourceMappingURL=ConversationInspectorResource.mocks.js.map